module.exports = __webpack_public_path__ + "img/dreamstime_m_142919009.0f64b298.jpg";